<template>
  <v-container class="mt-5">
    <DlgConfirmCancel ref="confirm"></DlgConfirmCancel>
    <v-card
      class="px-2 pb-6">
      <v-row>
        <v-col cols="9">
          <p>Modelo de Coparticipação - Listar</p>
        </v-col>
        <v-col cols="3" class="d-flex flex-row justify-end">
          <v-btn small @click="edit" v-if="selected.length == 1">
            <v-icon small title="Editar">fas fa-edit</v-icon>
          </v-btn>
          <v-btn class="mr-1" small @click="removeAll" v-if="selected.length">
            <v-icon small title="Remover Selecionados">fas fa-trash</v-icon>
          </v-btn>
          <v-btn class="mr-1" small @click="create">
            <v-icon small title="Criar">fas fa-plus</v-icon>
          </v-btn>
          <v-btn small @click="findAll">
            <v-icon small title="Buscar">fas fa-search</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-divider class="mb-4"></v-divider>

      <v-row>
        <v-col cols="6">
          <v-text-field
              dense
              label="Ordem"
              type="number"
              min="0"
              v-model="shareModel.code"
              outlined
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
              dense
              label="Descrição"
              type="text"
              min="0"
              v-model="shareModel.description"
              outlined
          />
        </v-col>
        <v-col cols="4">
          <v-checkbox
              dense
              label="Selecionar Inativos"
              v-model="shareModel.active"
              :true-value="false"
              :false-value="true"
              outlined
          />
        </v-col>
      </v-row>

      <v-container fluid v-if="itemsTotal">
        <v-row>
          <v-col cols="12">
            <v-data-table
                v-model="selected"
                :headers="headers"
                :items="items"
                :options.sync="options"
                :server-items-length="itemsTotal"
                item-key="id"
                locale="pt-BR"
                show-select
                class="elevation-1 mt-2"
                @click:row="show"
            >
              <template v-slot:item.active  ="{ item }">
                {{ item.active ? 'Sim' : 'Não' }}
              </template>
            </v-data-table>
            </v-col>
          </v-row>
        </v-container>
    </v-card>
  </v-container>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import DlgConfirmCancel from '@/components/dlg-confirm_cancel.vue';
import XippAuthService from "@/services/auth/XippAuthService";

export default {
  components: {DlgConfirmCancel},
  data() {
    return {
      shareModel: {
        code: null,
        description: null,
        active: true
      },
      headers: [
        { text: 'Ordem', align: 'end', value: 'code'},
        { text: 'Descrição', align: 'left', value: 'description'},
        { text: 'Ativo', align: 'center', value: 'active'}
      ],
      options: {},
      items: [],
      itemsTotal: null,
      singleSelect: false,
      selected: [],
    };
  },
  beforeCreate() {
    this._xippAuthService = new XippAuthService();
  },
  async created() {
    await this.loadJWTToken();
  },
  watch: {
    options: {
      handler() {
        this.findAll()
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters("shareModel", ["shareModelProcessed", "getShareModels"]),
  },
  methods: {
    ...mapActions("shareModel", ["deleteShareModel", "fetchShareModels"]),
    ...mapMutations(["toogleDialogLoading"]),
    async loadJWTToken() {
      if(this.$route.query && this.$route.query.token) {
        const sessionKey = "access_token";

        localStorage.setItem(sessionKey, this.$route.query.token);
        this.toogleDialogLoading(true);

        await this._xippAuthService.GetTokenFull()
          .then((response) => {
            if(response && response.data) {
              localStorage.setItem(sessionKey, response.data.token);
            }
          })
          .finally(() => {
            this.toogleDialogLoading(false);
          });
      }
    },
   findAll() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      this.toogleDialogLoading(true);

      this.fetchShareModels(
              Object.assign(
                  this.shareModel,
                  {
                    page: page ? page - 1 : 0,
                    sortBy: sortBy && sortBy.length? sortBy[0] : 'code',
                    descending: sortDesc && sortDesc.length? sortDesc[0] : false,
                    size: itemsPerPage
                  }
              )
          ).then((data) => {
            this.items = data.content;
            this.itemsTotal = data.totalElements;
          }).finally(() => {
            this.toogleDialogLoading(false);
          });
    },
    async removeAll() {
      this.toogleDialogLoading(true);
      if (this.selected.length && await this.$refs.confirm.show('Atenção', "Deseja excluir os registros selecionados?")) {
        for (const shareModel of this.selected) {
          await this.deleteShareModel(shareModel.id)
        }
        this.findAll();
      } else {
        this.toogleDialogLoading(false);
      }
    },
    edit() {
      this.$router.push(`/share_model/${this.selected[0].id}/edit`)
    },
    create() {
      this.$router.push('/share_model/new');
    },
    show(value) {
      this.$router.push(`/share_model/${value.id}/show`)
    }
  },
};
</script>


